import { render, staticRenderFns } from "./PerformerMessageItem.vue?vue&type=template&id=cc455500&scoped=true&"
import script from "./PerformerMessageItem.vue?vue&type=script&lang=js&"
export * from "./PerformerMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./PerformerMessageItem.vue?vue&type=style&index=0&id=cc455500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc455500",
  null
  
)

export default component.exports